/**
 * Created by AlexanderC on 5/27/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Extractable = undefined;

var _Interface2 = require('../../OOP/Interface');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Extractable helper
 */
let Extractable = exports.Extractable = function (_Interface) {
  _inherits(Extractable, _Interface);

  function Extractable() {
    _classCallCheck(this, Extractable);

    return _possibleConstructorReturn(this, (Extractable.__proto__ || Object.getPrototypeOf(Extractable)).call(this, ['extract']));
  }

  return Extractable;
}(_Interface2.Interface);


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/AWS/IAM/Extractable.js
// module id = 46
// module chunks = 0